import { QuestionContent, QuestionHeader, QuestionResponse, ResponseLayout } from "../../Layouts";
import TextResponseContent from "./TextResponseContent";
import TextResponseModal from "./TextResponseModal";

export default function TextResponse() {
    return (
        <ResponseLayout>
            <QuestionResponse>
                <QuestionHeader>
                    <TextResponseModal />
                </QuestionHeader>
                <QuestionContent>
                    <TextResponseContent />
                </QuestionContent>
            </QuestionResponse>
        </ResponseLayout>
    );
}
